import { t } from 'i18next';
import React, { CSSProperties } from 'react';

import MModal from 'Components/modal/MModal/MModal';

import styles from './MRemoveLanguage.style';

export type MRemoveLanguageProps = {
  content?: string;
  style?: CSSProperties;
  visible: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isLoading: boolean;
};

export const MRemoveLanguage = ({ content, style, onConfirm, onClose, visible, isLoading }: MRemoveLanguageProps) => {
  return (
    <MModal
      labelActionButton={t('activities:modals.remove_language.button')}
      labelSecondButton={t('activities:modals.remove_language.cancel')}
      actionButtonType="destructive"
      onAction={onConfirm}
      onCloseModal={onClose}
      onSecondAction={onClose}
      title={t('activities:modals.remove_language.title')}
      visible={visible}
      style={{ ...styles.modal, ...style }}
      bodyStyle={styles.contentWrapper}
      isActionLoading={isLoading}
    >
      {content ?? t('activities:modals.remove_language.content')}
    </MModal>
  );
};

export default MRemoveLanguage;
